import superMeta from '../_CAT_ROOT_MODULE/metaCatRootModuleNode.mjs'

export default {
    ...superMeta,
    moduleIdProp: 'vmId',
    moduleType: 'VM',
    name: '程序域',
    type: 'CAT_ROOT_VM',
}
